module.exports = __webpack_public_path__ + "img/icon-mob-website-expansion-item-arrow.3b5fa27.svg";